const visileColumns = [
  {
    title: "HR Control No",
    field: "HR_CONTROL",
    locked: false,
    filter: "text",
    show: true,
    width: 220,
  },
  {
    title: "Employee Id",
    field: "EmployeeID",
    locked: false,
    filter: "numeric",
    customFilterType: "CustomNumericText",
    className: "text-end",
    headerClassName: "number-align",
    show: true,
    width: 180,
  },
  {
    title: "Employee Name",
    field: "EmployeeName_LFM",
    locked: false,
    filter: "text",
    show: true,
    width: 200,
  },
  {
    title: "Current Status Name",
    field: "StatusName",
    locked: false,
    filter: "text",
    show: true,
    width: 200,
  },
  {
    title: "Previous Status Name",
    field: "PreviousStatusName",
    locked: false,
    filter: "text",
    show: true,
    width: 200,
  },
  {
    title: "Days Since Last Change",
    field: "DaysSinceLastChange",
    locked: false,
    filter: "numeric",
    customFilterType: "CustomNumericText",
    className: "text-end",
    headerClassName: "number-align",
    show: true,
    width: 180,
  },
  {
    title: "From Position Title",
    field: "From_Position_Title",
    locked: false,
    filter: "text",
    show: true,
    width: 200,
  },
  {
    title: "To Position Title",
    field: "To_Position_Title",
    locked: false,
    filter: "text",
    show: true,
    width: 200,
  },
  {
    title: "From Department",
    field: "From_Department",
    locked: false,
    filter: "text",
    show: true,
    width: 200,
  },
  {
    title: "To Department",
    field: "To_Department",
    locked: false,
    filter: "text",
    show: true,
    width: 200,
  },
  {
    title: "Nature Of Action",
    field: "NatureOfActionTitle",
    locked: false,
    filter: "text",
    show: true,
    width: 200,
  },
  {
    title: "Performed By",
    field: "EDIT_BY",
    locked: false,
    filter: "text",
    show: true,
    width: 200,
  },
  {
    title: "Action Effective Date",
    field: "Action_Effective_Date",
    locked: false,
    filter: "date",
    format: "MM/DD/yyyy hh:mm:ss A",
    editor: "date",
    show: true,
    width: 220,
  },
  {
    title: "Action Date",
    field: "Action_Date",
    locked: false,
    filter: "date",
    format: "MM/DD/yyyy hh:mm:ss A",
    editor: "date",
    show: true,
    width: 220,
  },
];

export default visileColumns;
